import React, { useState, useEffect, useCallback } from 'react';
import './Toast.css';

let _addToast = null;

export const toast = {
  success: (msg, duration) => _addToast?.({ type: 'success', msg, duration }),
  error:   (msg, duration) => _addToast?.({ type: 'error',   msg, duration }),
  info:    (msg, duration) => _addToast?.({ type: 'info',    msg, duration }),
  warning: (msg, duration) => _addToast?.({ type: 'warning', msg, duration }),
};

const CONFIG = {
  success: { icon: 'fa-solid fa-circle-check',  label: 'Sukces',    color: '#10b981', bg: '#f0fdf4', border: '#bbf7d0', progress: '#10b981' },
  error:   { icon: 'fa-solid fa-circle-xmark',  label: 'Błąd',      color: '#ef4444', bg: '#fef2f2', border: '#fecaca', progress: '#ef4444' },
  info:    { icon: 'fa-solid fa-circle-info',   label: 'Info',      color: '#3b82f6', bg: '#eff6ff', border: '#bfdbfe', progress: '#3b82f6' },
  warning: { icon: 'fa-solid fa-triangle-exclamation', label: 'Uwaga', color: '#f59e0b', bg: '#fffbeb', border: '#fde68a', progress: '#f59e0b' },
};

const ToastItem = ({ id, type, msg, duration = 3800, onRemove }) => {
  const [leaving, setLeaving] = useState(false);
  const cfg = CONFIG[type];

  useEffect(() => {
    const t1 = setTimeout(() => setLeaving(true), duration - 350);
    const t2 = setTimeout(() => onRemove(id), duration);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [id, duration, onRemove]);

  const dismiss = () => { setLeaving(true); setTimeout(() => onRemove(id), 350); };

  return (
    <div className={`toast-item toast-${type} ${leaving ? 'toast-leaving' : ''}`}
      style={{ '--toast-color': cfg.color, '--toast-bg': cfg.bg, '--toast-border': cfg.border }}>
      <div className="toast-icon-wrap">
        <i className={cfg.icon} style={{fontSize:'1.2em'}}></i>
      </div>
      <div className="toast-body">
        <span className="toast-label">{cfg.label}</span>
        <span className="toast-message">{msg}</span>
      </div>
      <button className="toast-dismiss" onClick={dismiss}>×</button>
      <div className="toast-progress"
        style={{ '--duration': `${duration}ms`, background: cfg.progress }} />
    </div>
  );
};

const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback(({ type, msg, duration }) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev.slice(-4), { id, type, msg, duration }]);
  }, []);

  useEffect(() => { 
    _addToast = addToast; 
    window.toast = toast;
    return () => { 
      _addToast = null; 
      delete window.toast;
    }; 
  }, [addToast]);

  const remove = useCallback((id) => setToasts(prev => prev.filter(t => t.id !== id)), []);

  return (
    <>
      {children}
      <div className="toast-portal">
        {toasts.map(t => <ToastItem key={t.id} {...t} onRemove={remove} />)}
      </div>
    </>
  );
};

export default ToastProvider;
